<template>
  <div v-if="display" id="confirm-modal" class="modal"
    aria-hidden="true"
    aria-labelledby="signInModalToggle"
    tabindex="-1">
      
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <span>{{ $t(title) }}</span>

          <button type="button"
            class="btn-close"
            @click="onCancel"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
        </div>

        <div class="modal-body">
          <div class="col-sm-12">
            <div v-html="content"></div>
          </div>
        </div>

        <div class="modal-footer">
          <button 
            type="button" 
            class="primary-btn-light-sm"
            @click="onSave">
            {{ $t(saveButton) }}
          </button>
        </div>        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmationModal",
  props:  {
    display: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    saveButton: {
      type: String,
      default: 'save'
    },  
    content: {
      type: String,
      default: ''
    },
  },
  methods:  {
    onCancel() {
      this.$emit('update:display', false);
    },
    onSave() {
      this.$emit('update:display', false);
      this.$emit('onSave');
    }
  },
  watch: {
    display(val) {
      if(val) {
        this.$nextTick(() => {
          this.modal = new bootstrap.Modal(document.getElementById('confirm-modal'), {});
          this.modal.show();
        })
      } else {
        this.modal.hide();
      }
    }
  }
};
</script>